import { AxiosResponse } from 'axios';
import {
  ExtensiveAttributeValueBulkInsertRequest, ExtensiveAttributeValueBulkInsertResponse, ExtensiveAttributeValueBulkUpdateRequest, ExtensiveAttributeValueBulkUpdateResponse, ExtensiveAttributeValueInsertResponse, ExtensiveAttributeValueUpdateResponse,
} from 'types/entity';
import { http } from './settings';

export const postExtensiveAttributeValues = (
  projectId: string,
  extensiveAttributeDefinitionId: string,
  attributeValues: ExtensiveAttributeValueBulkInsertRequest,
): Promise<ExtensiveAttributeValueInsertResponse[]> => http.post(`/projects/${projectId}/user-extensive-attribute-definitions/${extensiveAttributeDefinitionId}/values`, attributeValues)
  .then((response: AxiosResponse<ExtensiveAttributeValueBulkInsertResponse>) => response.data.results || []);

export const putExtensiveAttributeValues = (
  projectId: string,
  extensiveAttributeDefinitionId: string,
  attributeValues: ExtensiveAttributeValueBulkUpdateRequest,
): Promise<ExtensiveAttributeValueUpdateResponse[]> => http.put(`/projects/${projectId}/user-extensive-attribute-definitions/${extensiveAttributeDefinitionId}/values`, attributeValues)
  .then((response: AxiosResponse<ExtensiveAttributeValueBulkUpdateResponse>) => response.data.results || []);

export const deleteExtensiveAttributeValues = (
  projectId: string,
  extensiveAttributeDefinitionId: string,
  extensiveAttributeValueId: string,
): Promise<void> => http.delete(`/projects/${projectId}/extensive-attribute-definitions/${extensiveAttributeDefinitionId}/values/${extensiveAttributeValueId}`);
